import {Component, ElementRef, Input} from '@angular/core';
import {OnInit} from '@angular/core';
import {RemaxMarker} from '../../../../../classes/remax-marker';
import {CustomMarker, NguiMap, NguiMapComponent} from '@ngui/map';
import {CommunicationService} from '../../../../../services/communication.service';

// (45-30) / 500
// 45 is the maximum width/height the cluster can be, 30 is the minimum.
// for every listing in the cluster, up to 500, we increase the size of pin by 0.03px
export const RATIO = 0.03;

@Component({
  selector: 'ngui-map > app-listing-marker ',
  templateUrl: './listing-marker.component.html',
  styleUrls: ['./listing-marker.component.scss']
})
export class ListingMarkerComponent extends CustomMarker implements OnInit {
  @Input() position: Array<number>;
  @Input() marker: RemaxMarker;
  size: number;

  constructor(nguiMapComponent: NguiMapComponent,
              elementRef: ElementRef,
              private communicationService: CommunicationService,
              nguiMap: NguiMap) {
    super(nguiMapComponent, elementRef, nguiMap);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
